module.exports = __webpack_public_path__ + "static/threepcgreyknitted-f23745959eeb55a1eb1f1138b3810712.jpeg";